import "./assets/argon-base.scss";

export default {
    install() {},
};